import React from 'react';
import {
  IMeasureFieldsFragment,
  IMeasurePropertiesFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import * as BuilderInfoUI from '../../BuilderInfoUI';
import DataTableNamedMeasureInfo from './DataTableNamedMeasureInfo';
import { SimpleMeasureInfo } from '../../components/Measures';
import { assertCondition } from '../../../../utils/types';

interface IProps {
  measures: IMeasureFieldsFragment[];
  measuresProperties: IMeasurePropertiesFieldsFragment[];
}

export default ({ measures, measuresProperties }: IProps) => {
  return (
    <BuilderInfoUI.VerticalRow>
      {measures.map((measure, rowIndex) => {
        let properties = measuresProperties[rowIndex];

        if (properties.__typename === 'CompoundMeasureProperties') {
          properties = properties.measures[0];
        }

        // There are only 3 possible types in Data Table measures array:
        // basic simple measure, named simple measure, named compound measure
        if (measure.version) {
          return (
            <DataTableNamedMeasureInfo
              key={`data-table-measure-info-${rowIndex}`}
              measure={measure}
              cohorts={properties.cohortRefs}
              rowIndex={rowIndex}
            />
          );
        }

        assertCondition(measure.__typename === 'SimpleMeasure');

        return (
          <SimpleMeasureInfo
            key={`data-table-measure-info-${rowIndex}`}
            simpleMeasure={measure}
            cohorts={properties.cohortRefs}
            rowIndex={rowIndex}
          />
        );
      })}
    </BuilderInfoUI.VerticalRow>
  );
};
